// src/components/prestige/layout.js
import React, { useState, useEffect, useRef, useContext } from "react";
import {
  NavLink,
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import { logout } from "../../utils/auth";
import {
  LayoutDashboard,
  Bell,
  LogOut,
  LogIn,
  Users,
  Flame,
  Video,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  Shield,
  UserCheck,
  Trash2,
  Banknote,
  PackageOpen,
  Crown,
  Store,
  Focus,
  PenLine,
  Menu,
  X,
  User,
  SlidersHorizontal,
  FileBarChart,
} from "lucide-react";
import Dashboard from "./empDashboard";
import EmpAlerts from "./empAlerts";
import HygieneCompilance from "./hygieneCompilance";
import CaptainBehaviour from "./captainbahaviour";
// import WastageMonitoring from "./wastagemonitoring";
import CashCounter from "./cashcounter";
import MaterialInward from "./materialInward";
import StoreEntryEXit from "./storeentryexit";
import DiningAreaFootfall from "./footwalldiningarea";
import KababMonitoring from "./kababmonitoring";
import LiveStream from "./livestream";
import Roi from "./roi";
import Writer from "./writer";
// import TableOccupancy from "./tableoccupancy";
import UserManagement from "./usermanagement/viewusermanagement";
import AddUserManagement from "./usermanagement/addusermanagement";
import AlertBell from "./AlerBell";
import Report from "./report";
import { securePath, decodeSecurePath } from "../../utils/secureRoutes";
import axios from "../../utils/axiosDash";
import { RootContext } from "../../context/RootContext";
import Settings from "./empSettings";

const BASE_PATH = "/empirehome";

// Empire's own base path (the util defaults to /prestigehome)
const SECURE_OPTS = { basePath: BASE_PATH };

const ROUTE_KEYS = {
  dashboard: "dashboard",
  alerts: "alerts",
  hygieneSafety: "hygiene-safety",
  captainBehaviour: "captain-behaviour",
  wastageMonitoring: "wastage-monitoring",
  cashCounter: "cash-counter",
  materialInward: "material-inward",
  storeEntryExit: "store-entry-exit",
  diningAreaFootfall: "dining-area-footfall",
  kababMonitoring: "kabab-monitoring",
  liveStream: "live-stream",
  vms: "vms",
  nvr: "nvr",
  roi: "roi",
  writer: "writer",
  tableOccupancy: "table-occupancy",
  userManagement: "user-management",
  addUserManagement: "add-user-management",
  rulesSettings: "rules-settings",
  report: "report",
};

const routeComponentMap = {
  [ROUTE_KEYS.dashboard]: Dashboard,
  [ROUTE_KEYS.alerts]: EmpAlerts,
  [ROUTE_KEYS.hygieneSafety]: HygieneCompilance,
  [ROUTE_KEYS.captainBehaviour]: CaptainBehaviour,
  // [ROUTE_KEYS.wastageMonitoring]: WastageMonitoring,
  [ROUTE_KEYS.cashCounter]: CashCounter,
  [ROUTE_KEYS.materialInward]: MaterialInward,
  [ROUTE_KEYS.storeEntryExit]: StoreEntryEXit,
  [ROUTE_KEYS.diningAreaFootfall]: DiningAreaFootfall,
  [ROUTE_KEYS.kababMonitoring]: KababMonitoring,
  [ROUTE_KEYS.liveStream]: LiveStream,
  [ROUTE_KEYS.roi]: Roi,
  [ROUTE_KEYS.writer]: Writer,
  // [ROUTE_KEYS.tableOccupancy]: TableOccupancy,
  [ROUTE_KEYS.userManagement]: UserManagement,
  [ROUTE_KEYS.addUserManagement]: AddUserManagement,
  [ROUTE_KEYS.rulesSettings]: Settings,

  [ROUTE_KEYS.report]: Report,
};

const buildPath = (key) => securePath(`${BASE_PATH}/${key}`, SECURE_OPTS);

const navItems = [
  { label: "Dashboard", icon: LayoutDashboard, routeKey: ROUTE_KEYS.dashboard, path: buildPath(ROUTE_KEYS.dashboard) },
  { label: "Writer", icon: PenLine, routeKey: ROUTE_KEYS.writer, path: buildPath(ROUTE_KEYS.writer) },
  { label: "Hygiene & Safety", icon: Shield, routeKey: ROUTE_KEYS.hygieneSafety, path: buildPath(ROUTE_KEYS.hygieneSafety) },
  { label: "Cash Counter", icon: Banknote, routeKey: ROUTE_KEYS.cashCounter, path: buildPath(ROUTE_KEYS.cashCounter) },
  { label: "Store Entry", icon: LogIn, routeKey: ROUTE_KEYS.storeEntryExit, path: buildPath(ROUTE_KEYS.storeEntryExit) },
  { label: "Dining Area Footfall", icon: Users, routeKey: ROUTE_KEYS.diningAreaFootfall, path: buildPath(ROUTE_KEYS.diningAreaFootfall) },
  { label: "Kabab Monitoring", icon: Flame, routeKey: ROUTE_KEYS.kababMonitoring, path: buildPath(ROUTE_KEYS.kababMonitoring) },
  // { label: "Table Occupancy", icon: Users, routeKey: ROUTE_KEYS.tableOccupancy, path: buildPath(ROUTE_KEYS.tableOccupancy) },
  // { label: "Captain Behaviour", icon: UserCheck, routeKey: ROUTE_KEYS.captainBehaviour, path: buildPath(ROUTE_KEYS.captainBehaviour) },
  // { label: "Wastage Monitoring", icon: Trash2, routeKey: ROUTE_KEYS.wastageMonitoring, path: buildPath(ROUTE_KEYS.wastageMonitoring) },
  { label: "Material Inward", icon: PackageOpen, routeKey: ROUTE_KEYS.materialInward, path: buildPath(ROUTE_KEYS.materialInward) },
  { label: "Alerts", icon: Bell, routeKey: ROUTE_KEYS.alerts, path: buildPath(ROUTE_KEYS.alerts) },
  {
    label: "Report",
    icon: FileBarChart,
    routeKey: ROUTE_KEYS.report,
    path: buildPath(ROUTE_KEYS.report),
  },
  { label: "ROI", icon: Focus, routeKey: ROUTE_KEYS.roi, path: buildPath(ROUTE_KEYS.roi) },
  {
    label: "User Management",
    icon: Users,
    routeKey: ROUTE_KEYS.userManagement,
    path: buildPath(ROUTE_KEYS.userManagement),
  },
  { label: "Rules & Settings", icon: SlidersHorizontal, routeKey: ROUTE_KEYS.rulesSettings, path: buildPath(ROUTE_KEYS.rulesSettings) },
  { label: "VMS", icon: Video, routeKey: ROUTE_KEYS.liveStream, path: buildPath(ROUTE_KEYS.liveStream), disabled: true, premium: true },
  { label: "NVR", icon: Video, routeKey: ROUTE_KEYS.nvr, path: buildPath(ROUTE_KEYS.nvr), disabled: true, premium: true },
];

const STORE_OPTIONS = [
  "All Stores",
  "Church Street",
  "Kammanahalli",
  "Channapatna",
];

const STORE_STORAGE_KEY = "selectedStore";

// Tailwind md breakpoint (sidebar becomes a drawer below this)
const DESKTOP_QUERY = "(min-width: 768px)";

// ─────────────────────────────────────────────
// Module access helpers
// ─────────────────────────────────────────────

// Read the logged-in username from localStorage
const getStoredUsername = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.username) return user.username;
  } catch (e) {
    // ignore malformed JSON
  }

  // fallback to the login-session object
  try {
    const citriot = JSON.parse(localStorage.getItem("citriot"));
    return citriot?.auth?.user || "";
  } catch (e) {
    return "";
  }
};

// Dashboard is always allowed (landing page).
// User Management pages are admin-only.
// Everything else must be present in the user's moduleAccess.
const ROUTE_TO_MODULE_KEY = {
  dashboard: "dashboard",
  writer: "writer",
  "hygiene-safety": "hygiene_safety",
  "cash-counter": "cash_counter",
  "store-entry-exit": "store_entry",
  "dining-area-footfall": "dining_footfall",
  "kabab-monitoring": "kabab_monitoring",
  "table-occupancy": "table_occupancy",
  "wastage-monitoring": "wastage_monitoring",
  "material-inward": "material_inwards",
  alerts: "alerts",
  roi: "roi",
  "rules-settings": "rules_settings",
  report: "reports",
};

const canAccessRoute = (routeKey, access) => {
  if (!routeKey || routeKey === ROUTE_KEYS.dashboard) {
    return true;
  }

  if (
    routeKey === ROUTE_KEYS.userManagement ||
    routeKey === ROUTE_KEYS.addUserManagement
  ) {
    return access.empireAdmin === true;
  }

  const moduleKey = ROUTE_TO_MODULE_KEY[routeKey];

  return moduleKey
    ? access.modules.includes(moduleKey)
    : false;
};

// Decode current URL -> route key
const useActiveRouteKey = () => {
  const location = useLocation();
  const decoded = decodeSecurePath(location.pathname, location.search, SECURE_OPTS);

  return decoded
    ? decoded.replace(`${BASE_PATH}/`, "").replace(/^\//, "")
    : "";
};

const SecureRouteResolver = ({ access, accessLoading }) => {
  const routeKey = useActiveRouteKey();
  const navigate = useNavigate();

  // Wait until we know what this user is allowed to see
  if (accessLoading) {
    return (
      <div className="flex items-center justify-center h-[calc(100vh-60px)]">
        <div className="w-8 h-8 border-4 border-slate-200 border-t-blue-600 rounded-full animate-spin" />
      </div>
    );
  }

  // Block direct URL access to modules the user doesn't have
  if (!canAccessRoute(routeKey, access)) {
    return <Navigate to={buildPath(ROUTE_KEYS.dashboard)} replace />;
  }

  if (routeKey === ROUTE_KEYS.addUserManagement) {
    return (
      <AddUserManagement
        onBack={() =>
          navigate(buildPath(ROUTE_KEYS.userManagement))
        }
        onCreate={() =>
          navigate(buildPath(ROUTE_KEYS.userManagement))
        }
      />
    );
  }

  const Component = routeComponentMap[routeKey] ?? Dashboard;

  return <Component />;
};

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const activeRouteKey = useActiveRouteKey();

  // Logged-in username shown in the header (before the Empire logo)
  const username = getStoredUsername();

  // Desktop: collapse to icons. Mobile: open/close drawer.
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const { dispatch } = useContext(RootContext);

  // Module access for the logged-in user
  const [access, setAccess] = useState({
    empireAdmin: false,
    modules: [],
  });
  const [accessLoading, setAccessLoading] = useState(true);

  // Store dropdown state
  const [selectedStore, setSelectedStore] = useState(
    () => localStorage.getItem(STORE_STORAGE_KEY) || "All Stores"
  );
  const [storeDropdownOpen, setStoreDropdownOpen] = useState(false);
  const storeDropdownRef = useRef(null);

  // Fetch this user's modules + admin flag
  useEffect(() => {
    let cancelled = false;

    const fetchModules = async () => {
      const organizationId = localStorage.getItem("organizationId");
      const username = getStoredUsername();

      if (!organizationId || !username) {
        if (!cancelled) {
          setAccess({ empireAdmin: false, modules: [] });
          setAccessLoading(false);
        }
        return;
      }

      try {
        const res = await axios.post("/fetch-empire-user-modules", {
          organizationId,
          username,
        });

        const data = res?.data?.data || {};

        // Read the actual empireAdmin field from the backend.
        const empireAdmin = data.empireAdmin === true;

        // Extract moduleKey and include only enabled modules.
        const modules = (
          Array.isArray(data.moduleAccess) ? data.moduleAccess : []
        )
          .filter(
            (module) =>
              typeof module === "object" &&
              module !== null &&
              module.enabled === true
          )
          .map((module) =>
            String(module.moduleKey || "").trim().toLowerCase()
          )
          .filter(Boolean);

        if (!cancelled) {
          setAccess({
            empireAdmin,
            modules,
          });
        }
      } catch (error) {
        console.error("Error fetching user modules:", error);

        if (!cancelled) {
          setAccess({ empireAdmin: false, modules: [] });
        }
      } finally {
        if (!cancelled) {
          setAccessLoading(false);
        }
      }
    };

    fetchModules();

    return () => {
      cancelled = true;
    };
  }, []);

  // Close store dropdown on outside click / tap
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        storeDropdownRef.current &&
        !storeDropdownRef.current.contains(event.target)
      ) {
        setStoreDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  // Close mobile drawer whenever the route changes
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname, location.search]);

  // Close mobile drawer when resizing up to desktop
  useEffect(() => {
    const mq = window.matchMedia(DESKTOP_QUERY);
    const handleChange = (e) => {
      if (e.matches) setMobileOpen(false);
    };
    mq.addEventListener("change", handleChange);
    return () => mq.removeEventListener("change", handleChange);
  }, []);

  // Escape closes drawer / dropdown
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") {
        setMobileOpen(false);
        setStoreDropdownOpen(false);
      }
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, []);

  // Lock page scroll behind the mobile drawer
  useEffect(() => {
    if (!mobileOpen) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [mobileOpen]);

  const handleSelectStore = (store) => {
    if (store === selectedStore) {
      setStoreDropdownOpen(false);
      return;
    }
    localStorage.setItem(STORE_STORAGE_KEY, store);
    localStorage.setItem("storeSwitching", "true");
    setStoreDropdownOpen(false);
    window.location.reload();
  };

  const handleLogout = async () => {
    await logout();
    dispatch({ type: "LOGOUT" });
    navigate("/login", { replace: true });
  };

  // Bell drawer -> open the Alerts page focused on that one alert
  const handleOpenAlert = (alert) => {
    navigate(buildPath(ROUTE_KEYS.alerts), {
      state: {
        focusAlert: {
          id: alert.id,
          sourceKey: alert.sourceKey, // cashier | writer | storeroom | hygiene
          date: alert.date, // YYYY-MM-DD
        },
      },
    });
  };

  // Collapsed state only applies on md+ screens; the mobile drawer always shows labels
  const itemAlign = collapsed
    ? "justify-start gap-2.5 md:justify-center md:gap-0"
    : "justify-start gap-2.5";
  const hideWhenCollapsed = collapsed ? "md:hidden" : "";

  // Only show nav items this user is allowed to use.
  // Disabled premium items (VMS / NVR) stay visible as locked entries.
  const visibleNavItems = navItems.filter(
    (item) => item.disabled || canAccessRoute(item.routeKey, access)
  );

  // The bell links to the Alerts page, so only show it to users who can open it
  const showAlertBell =
    !accessLoading && canAccessRoute(ROUTE_KEYS.alerts, access);

  return (
    <div className="min-h-screen flex flex-col bg-slate-50 font-sans">
      {/* Top Bar */}
      <header className="sticky top-0 z-50 h-[60px] flex items-center px-3 sm:px-6 backdrop-blur-xl bg-white/95 border-b border-slate-200">
        {/* Mobile menu button */}
        <button
          onClick={() => setMobileOpen((prev) => !prev)}
          className="md:hidden mr-2 flex items-center justify-center w-9 h-9 shrink-0 rounded-lg border border-slate-200 bg-slate-50 text-slate-600 hover:bg-slate-100 transition-all"
          aria-label={mobileOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileOpen}
        >
          {mobileOpen ? <X size={18} /> : <Menu size={18} />}
        </button>

        <div className="flex items-center shrink-0 min-w-0">
          <div className="flex items-center justify-center">
            <img src="/logo.png" alt="Logo" className="h-[34px] sm:h-[42px] w-auto object-contain" />
          </div>
          <div className="mx-3 sm:mx-5 h-8 w-px bg-slate-200 hidden sm:block" />
          <div className="hidden sm:flex flex-col">
            <span className="text-[15px] font-bold tracking-[-0.3px] text-slate-900">
              CogniVision
            </span>
            <span className="hidden xl:block text-[10px] font-semibold tracking-[0.18em] text-slate-500 uppercase">
              Next Gen Video Analytics Platform
            </span>
          </div>
        </div>

        {/* Store Selector - centered on large screens, inline on smaller ones */}
        <div
          ref={storeDropdownRef}
          className="relative ml-auto lg:ml-0 lg:absolute lg:left-1/2 lg:top-1/2 lg:-translate-x-1/2 lg:-translate-y-1/2 z-10"
        >
          <button
            onClick={() => setStoreDropdownOpen((prev) => !prev)}
            className="flex items-center gap-2 px-3 sm:px-4 py-2 rounded-lg border border-slate-200 bg-slate-50 hover:bg-slate-100 transition-all text-[13px] font-semibold text-slate-700 min-w-[140px] sm:min-w-[180px] justify-between"
            aria-haspopup="listbox"
            aria-expanded={storeDropdownOpen}
          >
            <span className="flex items-center gap-2 min-w-0">
              <Store size={15} className="text-blue-600 shrink-0" />
              <span className="truncate">{selectedStore}</span>
            </span>
            <ChevronDown
              size={14}
              className={`shrink-0 text-slate-500 transition-transform duration-150 ${
                storeDropdownOpen ? "rotate-180" : ""
              }`}
            />
          </button>

          {storeDropdownOpen && (
            <div className="absolute top-[calc(100%+6px)] left-0 w-full min-w-[160px] bg-white border border-slate-200 rounded-lg shadow-lg overflow-hidden">
              {STORE_OPTIONS.map((store) => (
                <button
                  key={store}
                  onClick={() => handleSelectStore(store)}
                  className={`w-full text-left px-4 py-2.5 text-[13px] font-medium transition-all ${
                    selectedStore === store
                      ? "bg-blue-50 text-blue-600"
                      : "text-slate-600 hover:bg-slate-50"
                  }`}
                >
                  {store}
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="ml-3 lg:ml-auto flex items-center gap-2 sm:gap-4 shrink-0">
          {/* Unread alerts bell */}
          {showAlertBell && (
            <AlertBell
              storeName={selectedStore}
              username={username}
              onOpenAlert={handleOpenAlert}
            />
          )}

          {/* Logged-in username (shown before the Empire logo) */}
          {username && (
            <>
              <div
                className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-lg border border-slate-200 bg-slate-50 min-w-fit max-w-none"
                title={username}
              >
                <User size={15} className="text-blue-600 shrink-0" />
                <span className="text-[13px] font-semibold text-slate-700 whitespace-nowrap">
                  {username}
                </span>
              </div>
              <div className="h-8 w-px bg-slate-200 hidden sm:block" />
            </>
          )}
          <div className="hidden sm:flex items-center justify-center">
            <img src="/empirelogo.webp" alt="Logo 1" className="h-[42px] w-auto object-contain px-1" />
          </div>
          <div className="h-8 w-px bg-slate-200 hidden sm:block" />
          <button
            onClick={handleLogout}
            className="flex items-center justify-center w-9 h-9 rounded-lg border border-red-200 bg-red-50 text-red-600 hover:bg-red-100 transition-all hover:scale-105"
            title="Logout"
            aria-label="Logout"
          >
            <LogOut size={18} />
          </button>
        </div>
      </header>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-x-0 bottom-0 top-[60px] z-30 bg-slate-900/40 md:hidden"
          onClick={() => setMobileOpen(false)}
          aria-hidden="true"
        />
      )}

      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar: off-canvas drawer on mobile, fixed + collapsible on md+ */}
        <aside
          className={`
            fixed top-[60px] bottom-0 left-0 z-40
            bg-white border-r border-slate-200
            flex flex-col
            transition-all duration-300
            w-[260px] max-w-[85vw]
            ${mobileOpen ? "translate-x-0 shadow-xl" : "-translate-x-full"}
            md:translate-x-0 md:shadow-none md:max-w-none
            ${collapsed ? "md:w-16" : "md:w-[220px]"}
          `}
        >
          {/* Pinned header row: collapse toggle (desktop) / close (mobile) */}
          <div
            className={`shrink-0 flex justify-end ${
              collapsed ? "md:justify-center" : "md:justify-end"
            } px-3 pt-3 pb-1`}
          >
            <button
              onClick={() => setMobileOpen(false)}
              className="md:hidden w-7 h-7 rounded-md border border-slate-200 bg-slate-100 flex items-center justify-center text-slate-600 hover:bg-slate-200 transition-all"
              aria-label="Close menu"
            >
              <X size={14} />
            </button>
            <button
              onClick={() => setCollapsed(!collapsed)}
              className="hidden md:flex w-7 h-7 rounded-md border border-slate-200 bg-slate-100 items-center justify-center text-slate-600 hover:bg-slate-200 transition-all"
              aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
              {collapsed ? <ChevronRight size={14} /> : <ChevronLeft size={14} />}
            </button>
          </div>

          {/* Scrollable nav */}
          <nav
            className="
              flex-1 min-h-0
              overflow-y-auto overflow-x-hidden overscroll-contain
              px-2 py-2 pb-6
              flex flex-col gap-1
              [scrollbar-width:thin] [scrollbar-color:#cbd5e1_transparent]
              [&::-webkit-scrollbar]:w-1.5
              [&::-webkit-scrollbar-track]:bg-transparent
              [&::-webkit-scrollbar-thumb]:bg-slate-300
              [&::-webkit-scrollbar-thumb]:rounded-full
              hover:[&::-webkit-scrollbar-thumb]:bg-slate-400
            "
          >
            {visibleNavItems.map((item) => {
              const isActive = item.routeKey === activeRouteKey;

              if (item.disabled) {
                return (
                  <div
                    key={item.routeKey}
                    title={collapsed ? item.label : undefined}
                    className={`
                      flex items-center shrink-0
                      ${itemAlign}
                      px-3 py-2.5 rounded-[10px]
                      text-[13px] font-semibold
                      text-slate-400 bg-slate-50 cursor-not-allowed
                      border border-transparent
                      opacity-70
                    `}
                  >
                    <item.icon size={17} color="#94a3b8" className="shrink-0" />
                    <span className={`flex-1 truncate ${hideWhenCollapsed}`}>{item.label}</span>
                    {item.premium && (
                      <Crown
                        size={14}
                        className={`text-amber-500 shrink-0 ${hideWhenCollapsed}`}
                        title="Premium"
                      />
                    )}
                  </div>
                );
              }

              return (
                <NavLink
                  key={item.routeKey}
                  to={item.path}
                  title={collapsed ? item.label : undefined}
                  className={`
                    flex items-center shrink-0
                    ${itemAlign}
                    px-3 py-2.5 rounded-[10px]
                    text-[13px] font-semibold
                    transition-all duration-150
                    border
                    ${
                      isActive
                        ? "bg-blue-50 text-blue-600 border-blue-100"
                        : "text-slate-500 border-transparent hover:bg-slate-100"
                    }
                  `}
                >
                  <item.icon
                    size={17}
                    color={isActive ? "#2563eb" : "#64748b"}
                    className="shrink-0"
                  />
                  <span
                    className={`flex-1 truncate ${hideWhenCollapsed}`}
                    style={{ color: isActive ? "#2563eb" : "#64748b" }}
                  >
                    {item.label}
                  </span>
                  {item.premium && (
                    <Crown
                      size={14}
                      className={`text-amber-500 shrink-0 ${hideWhenCollapsed}`}
                      title="Premium"
                    />
                  )}
                </NavLink>
              );
            })}
          </nav>
        </aside>

        {/* Main Content: no left margin on mobile, offset by sidebar on md+ */}
        <main
          className={`flex-1 min-w-0 overflow-y-auto min-h-[calc(100vh-60px)] bg-slate-50 transition-all duration-300 ml-0 ${
            collapsed ? "md:ml-16" : "md:ml-[220px]"
          }`}
        >
          <Routes>
            <Route
              path="*"
              element={
                <SecureRouteResolver
                  access={access}
                  accessLoading={accessLoading}
                />
              }
            />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default Layout;